import React from "react";

interface ProgressBarProps {
  totalSteps: number;
  step: number;
}

export const ProgressBar: React.FC<ProgressBarProps> = ({
  totalSteps,
  step,
}) => {
  const percentage = (step / totalSteps) * 100;

  return (
    <div className="w-4/5 h-1 bg-[#EFEFEF] rounded-full overflow-hidden">
      <div
        style={{ width: `${percentage}%` }}
        className="h-full bg-[#E3B505]"
      />
    </div>
  );
};
